import {FC} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import cloneDeep from 'lodash/cloneDeep'
import {RootState} from 'setup'
import {
  setOrderBy,
  cancelOrder,
  setFilter,
  setPagingSizeChange,
  selectOrdersTotalCount,
  selectShowDialog,
  selectIsSubmitting,
  selectIsFetching,
  selectFilter,
  selectOrders,
} from '../redux/order/ordersSlice'
import {setCurrentPage} from 'app/redux/pagingSlice'
import {toDateEndOfUTC, toDateStartOfUTC} from 'app/format/date'
import OrderTableWrapper from './list/OrderTableWrapper'
import {PagingWithFilterAction} from 'app/components/pagination'

type Props = {}
const AllOrdersTableList: FC<Props> = () => {
  const dispatch = useDispatch()
  const paging = useSelector<RootState>(({misc}) => misc.paging) as any
  const totalCount = useSelector<RootState, number>(selectOrdersTotalCount)
  const showDeleteDialog = useSelector<RootState, boolean>(selectShowDialog)
  const isSubmitting = useSelector<RootState, boolean>(selectIsSubmitting)
  const isFetching = useSelector<RootState, boolean>(selectIsFetching)
  const filter = useSelector<RootState, any>(selectFilter)
  const orders = useSelector<RootState, any[]>(selectOrders)

  const handlePageChange = async (currentPage: any) => {
    const offset = (currentPage - 1) * paging.pageSize
    dispatch(setPagingSizeChange({...filter, offset, currentPage}))
  }

  const handleSort = async (orderBy: any) => {
    dispatch(setOrderBy(orderBy))
  }

  const handleCancel = async (orderId: string) => {
    let pageIndex = paging.currentPage - 1
    const offset = pageIndex * paging.pageSize
    if (orders.length === 1) {
      pageIndex -= 1
      dispatch(setCurrentPage(paging.currentPage - 1))
    }

    dispatch(cancelOrder({orderId, filter, offset}))
  }

  const handleFilter = (filter: any) => {
    dispatch(setFilter(filter))
  }

  const handleFilterChange = (filter: any) => {
    handleFilter({...filter, offset: 0, currentPage: 1})
  }

  const exportFilter = () => {
    const model = cloneDeep({...filter, endDate: null})
    if (model.fromDate) {
      model.fromDate = toDateStartOfUTC(filter.fromDate)
      model.toDate = toDateEndOfUTC(filter.toDate)
    }
    return model
  }

  return (
    <>
      <OrderTableWrapper
        isFetching={isFetching}
        showDeleteDialog={showDeleteDialog}
        isSubmitting={isSubmitting}
        totalCount={totalCount}
        exportFilter={exportFilter()}
        onFilterChange={handleFilterChange}
        title='Orders'
        filter={filter}
        orders={orders}
        onOrderBy={handleSort}
        onCancel={handleCancel}
        onPageChange={handlePageChange}
      />
      <PagingWithFilterAction onFilterChange={handleFilter} />
    </>
  )
}

export default AllOrdersTableList
